module.exports = __webpack_public_path__ + "img/C03TechHorsemanMaster_ua.ddebae14.webp";